(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["firstaidkit-form"] && !Shopify.designMode) return;
  try {
    
  const API_URL = 'https://api.dashboard.livingstone.com.au';

  class FirstAidKitRegistration extends HTMLElement {
    form = null;
    submitButton = null;
    registrationType = null;

    constructor() {
      super();
    }

    connectedCallback() {
      this._init();
      this._addEventListeners();
      this._loadInitialRecommendations();
      
      // Listen for GST toggle changes
      document.addEventListener('price:rerender', () => {
        const targetDiv = document.querySelector('.fak-products-grid');
        const currentProducts = this.currentProducts;
        if (currentProducts && targetDiv) {
          this.renderProducts(currentProducts, targetDiv);
        }
      });
    }

    _init() {
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('button[type="submit"]');
      this.registrationType = this.dataset.registrationType;
    }

    _addEventListeners() {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));

      // Add click handler for add to cart buttons
      this.addEventListener('click', async (event) => {
        const addToCartButton = event.target.closest('.fak-product-card__add');
        if (addToCartButton) {
          const variantId = addToCartButton.closest('.product-item__info').querySelector('.product-item__title').id;
          const quantityInput = addToCartButton.closest('.fak-product-card').querySelector('.quantity-selector__value');
          const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

          await this.addToCart(variantId, quantity);
        }

        // Add handler for "Add All to Cart" button
        const addAllButton = event.target.closest('.add-to-cart__submit');
        if (addAllButton) {
          await this.addAllToCart();
        }
      });
    }

    async _getRecommendations(data) {
      try {
        // Log initial form data
        // console.log('Initial form data:', data);

        const couponInput = document.querySelector('.coupon-input');
        let couponValue = couponInput?.value;

        if (!couponValue) {
          const storageValue = localStorage.getItem('coupon_code');
          if (storageValue) {
            couponValue = storageValue;
          }
        }

        // Get the floors value from the input
        const floorsInput = this.querySelector('#floors');
        const numberOfFloors = floorsInput ? floorsInput.value : 1;

        // Add floors to the data object
        const requestData = {
          ...data,
          floors: numberOfFloors,
          accountCode: document.body?.dataset?.companyExternalId,
          campaignCode: couponValue,
        };

        // Log request data before sending
        // console.log('Request data being sent:', requestData);

        const response = await fetch(`${API_URL}/first-aid/search`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestData),
        });

        const recommendations = await response.json();

        // Log API response
        // console.log('API Response:', recommendations);

        const targetDiv = document.querySelector('.fak-products-grid');
        this.currentProducts = recommendations; // Store for re-rendering
        this.renderKitCount(numberOfFloors, data["contact[risk_type]"], data["contact[employees]"]);
        this.renderProducts(recommendations, targetDiv);
        this.toggleSummary(recommendations.length > 0);
      } catch (error) {
        console.error('Error fetching recommendations:', error);
      }
    }

    async _populateIndustries() {
      try {
        // Trust
        const industries = [
          { value: 'WORK PLACE', name: 'Work Place' },
          { value: 'CONSTRUCTION', name: 'Construction' },
          { value: 'SPORTS', name: 'Sports' },
          { value: 'ELECTRICAL', name: 'Electrical' },
          { value: 'CHILD CARE', name: 'Child Care' },
          { value: 'TRAVEL', name: 'Travel' },
          { value: 'HOSPITALITY/RESTAURANT', name: 'Hospitality' },
          { value: 'POLICE VEHICLE', name: 'Police Vehicle' },
          { value: 'MARINE', name: 'Marine' },
          { value: 'DENTAL', name: 'Dental' },
          { value: 'TRUCK', name: 'Truck' },
          { value: 'VEHICLE/AUTO', name: 'Vehicle' },
          { value: 'WORK VEHICLE', name: 'Work Vehicle' },
        ];
        const industrySelect = this.querySelector('select#industry');

        industries.forEach((industry, index) => {
          const option = document.createElement('option');
          option.value = industry.value;
          option.innerText = industry.name;
          if (index === 0) {
            option.selected = true;
          }
          industrySelect.appendChild(option);
        });

        return true;
      } catch (error) {
        console.error('Error fetching industries:', error);
        return false;
      }
    }

    async _loadInitialRecommendations() {
      // Wait for industries to load first
      await this._populateIndustries();

      // Get all form inputs
      const formData = new FormData(this.form);
      const data = Object.fromEntries(formData);

      // Load initial recommendations
      try {
        await this._getRecommendations(data);
      } catch (error) {
        console.error('Error loading initial recommendations:', error);
      }
    }

    validateForm() {
      let isValid = true;
      const requiredFields = this.form.querySelectorAll('[required]');

      requiredFields.forEach((field) => {
        const errorMessage = field.nextElementSibling;
        if (!field.value.trim()) {
          field.classList.add('fak-form__error');
          if (errorMessage && errorMessage.classList.contains('error-message')) {
            errorMessage.textContent = 'This field is required.';
          } else {
            const error = document.createElement('div');
            error.className = 'error-message';
            error.textContent = 'This field is required.';
            field.parentNode.insertBefore(error, field.nextSibling);
          }
          isValid = false;
        } else {
          field.classList.remove('fak-form__error');
          if (errorMessage && errorMessage.classList.contains('error-message')) {
            errorMessage.textContent = '';
          }
        }
      });

      return isValid;
    }

    async handleSubmit(event) {
      event.preventDefault();

      if (!this.validateForm()) {
        return;
      }

      const formData = new FormData(this.form);
      const data = Object.fromEntries(formData);

      try {
        await this._getRecommendations(data);
      } catch (error) {
        console.error('Error submitting form:', error);
      }
    }

    async addToCart(variantId, quantity) {
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(variantId, 10),
                quantity: quantity,
              },
            ],
          }),
        });

        const result = await response.json();

        if (response.ok) {
          // Optional: Show success message
          console.log('Added to cart:', result);

          // Optional: Update cart drawer if it exists
          document.documentElement.dispatchEvent(
            new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                quantity: 1,
              },
            })
          );
        } else {
          throw new Error(result.description || 'Error adding to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        alert(error.message);
      }
    }

    async addAllToCart() {
      try {
        // Get all product cards
        const productCards = this.querySelectorAll('form[data-fak]');
        const items = [];

        // Collect variant IDs and quantities from all cards
        productCards.forEach((card) => {
          const variantId = card.querySelector('input[name="id"]').value;
          const quantity = card.querySelector('input[name="quantity"]').value;
          // const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

          if (variantId && quantity) {
            items.push({
              id: parseInt(variantId, 10),
              quantity: quantity,
            });
          }
        });

        // Add all items to cart
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items }),
        });

        const result = await response.json();

        if (response.ok) {
          console.log('Added all items to cart:', result);

          // Trigger cart refresh
          document.documentElement.dispatchEvent(
            new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                quantity: items.reduce((total, item) => total + item.quantity, 0),
              },
            })
          );
        } else {
          throw new Error(result.description || 'Error adding items to cart');
        }
      } catch (error) {
        console.error('Error adding all items to cart:', error);
        alert(error.message);
      }
    }

    renderProducts(products, targetDiv) {
      if (!targetDiv) {
        return;
      }

      if (products.length == 0) {
        targetDiv.innerHTML =
          '<div style="display:flex;justify-content:center;align-items:center;height: 5em;width:100%;font-size:2em"><div>No Results</div></div>';
        return;
      }

      const productTable = (p) => {
        if (!p.priceBreaksAttribute) {
          return '';
        }

        // Check GST toggle state
        const gstToggle = document.querySelector('#gst-toggle-input');
        const gstDisabled = gstToggle?.checked == false;

        const breaks = JSON.parse(p.priceBreaksAttribute)?.breaks;
        const tax = JSON.parse(p.priceBreaksAttribute)?.taxRate;
        const taxable = tax != 100;

        if (!breaks || breaks[0].quantity == 0 || breaks[0].quantity == 999999) {
          return '';
        }

        const cells = breaks
          .map((b) => {
            if (b.quantity == 0) {
              return '';
            }

            // Calculate price based on GST toggle
            const displayPrice = gstDisabled 
              ? b.value.toFixed(2)
              : ((b.value * tax) / 100).toFixed(2);

            return `
         <tr style="border-bottom: 1px solid #eee;">
          <td
            style="text-align: center; border: 1px solid #ddd;"
          >
            ${b.quantity}+
          </td>
          <td
            style="text-align: center; border: 1px solid #ddd;"
          >
            ${displayPrice}
          </td>
        </tr>`;
          })
          .join('');

        // Dynamic label based on toggle state and tax
        // GST-free products always show "GST Free", taxable products show based on toggle
        const priceLabel = taxable 
          ? (gstDisabled ? '(Ex. GST)' : '(Inc. GST)')
          : '(GST Free)';

        return `<div class="price-breaks-table-wrapper" id="${p.variant_id}__price-breaks" style="margin-bottom: 1em;">
        <table style="width:100%; border-collapse: collapse;">
          <thead>
            <tr>
              <th style="border: 1px solid #ddd;">Quantity</th>
              <th style="border: 1px solid #ddd;">
                    Price ${priceLabel}
              </th>
            </tr>
          </thead>
          <tbody>
            ${cells}
          </tbody>
        </table>
      </div>`;
      };

      const productHTML = products
        .map(
          (product) => `
        <div class="product-item product-item--vertical 1/3--tablet-and-up 1/3--desk">
          <div
            data-product-skus="${product.sku}"
          ></div>
            <a href="${product.url}" class="product-item__image-wrapper">
              <div class="aspect-ratio aspect-ratio--short">
                <img src="${product.image_url}" alt="${product.title}" width="567" height="567">
              </div>
            </a>
            <div class="product-item__info">
              <div class="product-item__info-inner"> ${product.sku}
                <a href="${product.url}" class="product-item__title text--strong link">${product.title}</a>
                <div class="show-in-list">
                  ${product.sku}
                </div>
              </div>
              <form method="post" action="/cart/add" accept-charset="UTF-8" class="product-item__action-list button-stack" enctype="multipart/form-data" data-fak>
                <input type="hidden" name="form_type" value="product">
                <input type="hidden" name="utf8" value="✓">
                <input type="hidden" name="id" value="${product.variant_id}">
                <input type="text" hidden="" id="priceBreaks" data-variant-sku="${product.sku}" 
                  name="properties[_priceBreaks]" readonly="" value='${product.priceBreaksAttribute}'>
                <input type="text" hidden="" id="companyExternalId" name="properties[__customer_external_id]" value="${document.body?.dataset?.companyExternalId}" readonly>
                ${productTable(product)}
                <div class="quantity-selector d-flex justify-end unit px-2">
                  <input class="quantity-selector__value" name="quantity" value="1" style="text-align:right">
                  <div> units </div>
                </div>
                <button type="submit" class="product-item__action-button button button--small button--primary" data-action="add-to-cart">Add to cart</button>
              </form>
            </div>
        </div>
        `
        )
        .join('');

      targetDiv.innerHTML = productHTML;
    }

    toggleSummary(hasResults) {
      const summaryDiv = this.querySelector('[data-fak-recommendations-atc]');
      const noResultsDiv = this.querySelector('[data-fak-recommendations-no-results]');
      if (hasResults) {
        summaryDiv.classList.remove('fak-d-none');
        noResultsDiv.classList.add('fak-d-none');
      } else {
        summaryDiv.classList.add('fak-d-none');
        noResultsDiv.classList.remove('fak-d-none');
      }
    }

    renderKitCount(numberOfFloors, riskType, numberOfEmployees){
      // always recommend a single kit for a single employee
      if (numberOfEmployees == 1){
        return 1
      }

      // set minimum based on number of floors
      let kitsNeeded = Math.ceil((parseInt(numberOfFloors) + 1) / 2)

      if(riskType == "Low"){
        if (numberOfEmployees <= 200){
          kitsNeeded = Math.max(kitsNeeded, Math.ceil((numberOfEmployees - 1)/  50 + 1))
        } else {
          kitsNeeded = Math.max(kitsNeeded, Math.ceil((numberOfEmployees - 1)/  100 + 3))
        }
      } else if (riskType == "High"){
        if (numberOfEmployees <= 50){
          kitsNeeded = Math.max(kitsNeeded, Math.ceil((numberOfEmployees - 1)/  25 + 1))
        } else {
          kitsNeeded = Math.max(kitsNeeded, Math.ceil((numberOfEmployees - 1)/  50 + 3))
        }
      }


      const kitsNeededElement = this.querySelector('[data-kits-needed]');
      kitsNeededElement.textContent = kitsNeeded;
    }
  }

  customElements.define('fak-registration', FirstAidKitRegistration);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndis-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    window.requestAnimFrame = (function (callback) {
      return (
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimaitonFrame ||
        function (callback) {
          window.setTimeout(callback, 1000 / 60);
        }
      );
    })();

    var canvas = document.getElementById('sig-canvas');
    var ctx = canvas.getContext('2d');
    ctx.strokeStyle = '#222222';
    ctx.lineWidth = 2;

    var drawing = false;
    var mousePos = {
      x: 0,
      y: 0,
    };
    var lastPos = mousePos;

    canvas.addEventListener(
      'mousedown',
      function (e) {
        drawing = true;
        lastPos = getMousePos(canvas, e);
      },
      false
    );

    canvas.addEventListener(
      'mouseup',
      function (e) {
        drawing = false;
      },
      false
    );

    canvas.addEventListener(
      'mousemove',
      function (e) {
        mousePos = getMousePos(canvas, e);
      },
      false
    );

    // Add touch event support for mobile
    canvas.addEventListener('touchstart', function (e) {}, false);

    canvas.addEventListener(
      'touchmove',
      function (e) {
        var touch = e.touches[0];
        var me = new MouseEvent('mousemove', {
          clientX: touch.clientX,
          clientY: touch.clientY,
        });
        canvas.dispatchEvent(me);
      },
      false
    );

    canvas.addEventListener(
      'touchstart',
      function (e) {
        mousePos = getTouchPos(canvas, e);
        var touch = e.touches[0];
        var me = new MouseEvent('mousedown', {
          clientX: touch.clientX,
          clientY: touch.clientY,
        });
        canvas.dispatchEvent(me);
      },
      false
    );

    canvas.addEventListener(
      'touchend',
      function (e) {
        var me = new MouseEvent('mouseup', {});
        canvas.dispatchEvent(me);
      },
      false
    );

    function getMousePos(canvasDom, mouseEvent) {
      var rect = canvasDom.getBoundingClientRect();
      return {
        x: mouseEvent.clientX - rect.left,
        y: mouseEvent.clientY - rect.top,
      };
    }

    function getTouchPos(canvasDom, touchEvent) {
      var rect = canvasDom.getBoundingClientRect();
      return {
        x: touchEvent.touches[0].clientX - rect.left,
        y: touchEvent.touches[0].clientY - rect.top,
      };
    }

    function renderCanvas() {
      if (drawing) {
        ctx.moveTo(lastPos.x, lastPos.y);
        ctx.lineTo(mousePos.x, mousePos.y);
        ctx.stroke();
        lastPos = mousePos;
      }
    }

    // Prevent scrolling when touching the canvas
    document.body.addEventListener(
      'touchstart',
      function (e) {
        if (e.target == canvas) {
          e.preventDefault();
        }
      },
      false
    );
    document.body.addEventListener(
      'touchend',
      function (e) {
        if (e.target == canvas) {
          e.preventDefault();
        }
      },
      false
    );
    document.body.addEventListener(
      'touchmove',
      function (e) {
        if (e.target == canvas) {
          e.preventDefault();
        }
      },
      false
    );

    (function drawLoop() {
      requestAnimFrame(drawLoop);
      renderCanvas();
    })();

    function clearCanvas() {
      canvas.width = canvas.width;
    }

    // Set up the UI
    var sigText = document.getElementById('sig-dataUrl');
    var clearBtn = document.getElementById('sig-clearBtn');
    clearBtn.addEventListener('click', function (e) {
      clearCanvas();
      sigText.innerHTML = '';
    });
    canvas.addEventListener('click', function (e) {
      console.log('canvas update');
      var dataUrl = canvas.toDataURL();
      sigText.innerHTML = dataUrl;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
